"use client";

export function ChatAccountLogout() {
  const logout = async () => {
    await fetch("/api/app-auth/logout", { method: "POST" });
    window.location.href = "/chat";
  };

  return (
    <button className="chat-account-overlay-logout" type="button" onClick={logout} title="退出登录" aria-label="退出登录">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <polyline points="16 17 21 12 16 7" />
        <line x1="21" y1="12" x2="9" y2="12" />
      </svg>
    </button>
  );
}
